import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";
import backBtn from "../../assets/images/backBtn.svg";
import EducationalContentHeader from "./EducationalContentHeader";
import {
    EducationalContentContinueButton,
    EducationalContentSecondaryButton,
} from "./EducationalContentContinueButton";
import { useDispatch, useSelector } from "react-redux";
import { reviewBenefitsHandler } from "../../redux/action/guestUserAction/reviewBenefits";

const EnrollmentDeclineConfirmation = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const enrollmentDecision = location.state?.enrollmentDecision;

    const reviewBenefitsSliceSelector = useSelector((state) => state.reviewBenefitsSlice);


    const handleBack = () => {
        navigate("/guest-user/enrollment");
    };


    useEffect(() => {
        // if (!enrollmentDecision) return;
    
        // const triggerReviewBenefits = async () => {
        //   try {
        //     await dispatch(reviewBenefitsHandler());
        //   } catch (error) {
        //     console.error("Failed to call review benefits API", error);
        //   }
        // };
    
        // triggerReviewBenefits();
        dispatch(reviewBenefitsHandler());
      }, []);

    const handleDeclineBenefits = () => {
        navigate("/guest-user/giving-up-confirm-option", { state: { enrollmentDecision: "NO" } });
    };
    useEffect(() => {
        if (enrollmentDecision !== "NO") {
            navigate("/guest-user/enrollment", { replace: true });
        }
    }, [enrollmentDecision, navigate]);

    return (
        <EducationalContentHeader
            backBtnSrc={backBtn}
            backBtnMobileSrc={backBtnMobile}
            onBack={handleBack}
            title={t("Review Benefits")}
            hideNavigation
        >
            <div className="stepperview mb-60">
                <div className="mb-24 belowline">
                    <h2 className="tgb fs-20 mb-12">{t("Are you sure you want to skip your coverage?")}</h2>
                    <p className="fs-16 lh-24">
                        {t("You’re about to remove benefits that support your care when you need it most.")}
                    </p>
                </div>
                <div className="paycheck-block">
                    <h3 className="tgb fs-20 mb-16">{t("What you’ll lose")}</h3>
                    <ul className="benefits-list fs-16 lh-24">
                        {reviewBenefitsSliceSelector?.data?.data?.benefits?.length > 0 ? (
                            reviewBenefitsSliceSelector.data.data.benefits.map((item, index) => (
                                <li key={`${item?.title}-${index}`}>
                                    {item?.title && (
                                        <span className="tgb fw-700">{(item.title)} -</span>
                                    )}
                                    {item?.title && item?.description ? " " : null}
                                    {item?.description ? (item.description) : null}
                                </li>
                            ))
                        ) : (
                            <li>{t("No data found")}</li>
                        )}
                    </ul>
                </div>
            </div>

            <EducationalContentContinueButton
                hideNavigation={false}
                onContinue={handleBack}
                // buttonLabel={t("No, Keep My Coverage")}
                buttonLabel={t("Continue")}
            />
            <EducationalContentSecondaryButton
                hideNavigation={false}
                onContinue={handleDeclineBenefits}
                // buttonLabel={t("Yes, Skip for Now")}
                buttonLabel={t("Skip for Now")}
            />
        </EducationalContentHeader>
    );
};

export default EnrollmentDeclineConfirmation;
